import MDBox from "components/MDBox";
import Dialog from "@mui/material/Dialog";
import MDTypography from "components/MDTypography";
import DataCard from "components/custom/DataCard";
import DialogContent from "@mui/material/DialogContent";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import Divider from "@mui/material/Divider";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import MDBackdrop from "components/MDBackdrop";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { useMaterialUIController } from "context";
import theme from "assets/theme";

function ViewUser(props) {
    const [isBackdrop] = useState(false);
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const { sidenavColor } = controller;
    const { onClose } = props;

    const handleClose = () => {
        onClose(false);
        window.location.reload();
    };


    return (
        <>
            <MDBackdrop isBackdrop={isBackdrop} />
            <Dialog open={props.isDialog} onClose={handleClose} fullWidth maxWidth="md">
                <DialogTitle style={darkMode ? { backgroundColor: "#202940", color: "#ffffff", display: "flex", alignItems: "center", justifyContent: "space-between" } : { theme, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    User information
                    <IconButton aria-label="delete" style={darkMode ? { color: "#ffffff" } : theme} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent style={darkMode ? { backgroundColor: "#202940", color: "#ffffff" } : theme}>
                    <MDBox pt={0} pb={0} style={{ display: "flex", justifyContent: "center",flexDirection : "column" }}>
                        <MDBox pt={6} pb={3}>
                            <Grid container spacing={6}>
                                <Grid item xs={12}>
                                    <Card>
                                        <MDBox
                                            mx={2}
                                            mt={-3}
                                            py={3}
                                            px={2}
                                            variant="gradient"
                                            bgColor={sidenavColor}
                                            borderRadius="lg"
                                            coloredShadow={sidenavColor}
                                        >
                                            <Grid container direction="row" justifyContent="space-between" alignItems="center">
                                                <MDTypography variant="h6" color="white">
                                                    Personal information
                                                </MDTypography>
                                            </Grid>
                                        </MDBox>

                                        <Grid container direction="row" p={2}>
                                            {(<DataCard title="First Name" value={props.value.first_name} count={3} />)}
                                            {(<DataCard title="Last Name" value={props.value.last_name} count={3} />)}
                                            {(<DataCard title="Driver ID" value={props.value.DriverId} count={3} />)}
                                            <Divider />
                                            {(<DataCard title="Email ID" value={props.value.email} count={3} />)}
                                            {(<DataCard title="Gender" value={props.value.gender} count={3} />)}
                                            {(<DataCard title="Date Of Birth" value={props.value.date_of_birth} count={3} />)}
    

                                        </Grid>
                                    </Card>
                                </Grid>
                            </Grid>
                        </MDBox>
 
                        <MDBox pt={6} pb={3}>
                            <Grid container spacing={6}>
                                <Grid item xs={12}>
                                    <Card>
                                        <MDBox
                                            mx={2}
                                            mt={-3}
                                            py={3}
                                            px={2}
                                            variant="gradient"
                                            bgColor={sidenavColor}
                                            borderRadius="lg"
                                            coloredShadow={sidenavColor}
                                        >
                                            <Grid container direction="row" justifyContent="space-between" alignItems="center">
                                                <MDTypography variant="h6" color="white">
                                                    Vehicle information
                                                </MDTypography>
                                            </Grid>
                                        </MDBox>
                                        <div style={{display:"flex", justifyContent:"center", alignItems:"center", paddingTop:"23px"}}>
                                        <div style={{marginLeft: "16px"}}>
                              
                                            <img style={{marginTop:"18px",
                                             
                                            }} src={process.env.REACT_APP_PUBLIC_URL + props.value.vehicle_img} alt="Variant"
                                       
                                              height={130} 
                                      
                                              srcset="" />
                                            </div>

                                        <Grid container direction="row" p={1} mt={-1}>
                                    
                                            {(<DataCard title="Type" value={props.value.type} count={2} />)}
                                            {(<DataCard title="Make" value={props.value.make} count={2} />)}
                                            {(<DataCard title="Model" value={props.value.model} count={2} />)}
                                            {(<DataCard title="Variant" value={props.value.variant} count={2} />)}
                                            <Divider />
                                            {(<DataCard title="Registeration Number" value={props.value.registeration_number} count={2} />)}
                                            {(<DataCard title="Range" value={props.value.range} count={2} />)}

                                        </Grid>
                                        </div>
                                    </Card>
                                </Grid>
                            </Grid>
                        </MDBox>
                    </MDBox>
                </DialogContent>
  
            </Dialog>
        </>
    );
}

export default ViewUser;